import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_billing_templates_show_edit = _resolveComponent("billing-templates-show-edit")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h5", null, "Billing template #" + _toDisplayString(_ctx.billingTemplateId), 1),
    _createVNode(_component_billing_templates_show_edit, {
      billingTemplate: _ctx.billingTemplate,
      organizationId: _ctx.organizationId,
      billingTemplateId: _ctx.billingTemplateId
    }, null, 8, ["billingTemplate", "organizationId", "billingTemplateId"]),
    _createVNode(_component_q_btn, {
      color: "primary",
      label: "Back to listing",
      to: { name: _ctx.OrganizationsRouteNames.SHOW, params: { organizationId: _ctx.organizationId }, query: { ..._ctx.$route.query } },
      outline: "",
      "no-caps": ""
    }, null, 8, ["to"])
  ]))
}